export const Haptics={impact(){},selection(){},notification(){},success(){},warning(){},error(){}};export*from"./type";